<template>
  <div class="signup-screen">
    <h2 class="mb-4">
      Account Sign Up
    </h2>
    <div class="mt-4 d-flex">
      Temporary functionality to make an account<br>
      For testing
    </div>
    <div class="signup-form has-border">
      <b-form-group>
        <label for="user-name">Username</label>
        <b-form-input
          id="user-name"
          v-model="userName"
          size="md"
          type="text"
        />
      </b-form-group>
      <b-form-group>
        <label for="email-id">Email</label>
        <b-form-input
          id="email-id"
          v-model="emailAddress"
          size="md"
          type="text"
        />
      </b-form-group>
      <b-form-group>
        <label for="ph-no">Phone</label>
        <b-form-input
          id="ph-np"
          v-model="phoneNumber"
          size="md"
          type="text"
          placeholder="Enter phone number"
          @change="handlePhoneNumberChange"
        />
      </b-form-group>
      <b-form-group>
        <label for="password">Password</label>
        <b-form-input
          id="password"
          v-model="password"
          size="md"
          type="text"
        />
      </b-form-group>
      <b-form-group>
        <div
          v-if="!!error"
          class="mr-4 alert alert-danger fade show"
          role="alert"
        >
          {{ error }}
        </div>
        <div class="ml-2 d-flex flex-nowrap align-content-end align-items-end">
          <b-button
            class="ml-2 mr-2"
            title="Cancel"
            :disabled="loading"
            @click="onCancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            title="Sign Up"
            @click="onSubmitSignUpForm"
            @keyup.13="onSubmitSignUpForm"
          >
            Sign Up
          </b-button>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUp',
  data: function () {
    return {
      authData: {},
      authState: '',
      showConfirm: false,
      error: '',
      loading: false,
      userName: '',
      emailAddress: '',
      phoneNumber: '',
      password: ''
    }
  },
  computed: {},
  methods: {
    handlePhoneNumberChange() {
    },
    onCancel() {
    },
    onSubmitSignUpForm() {
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss';
</style>

